import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { widgetNames } from "./helper";
const attrs = new NbiDimensions();
export function getAllAttributes(): [{ field: string; headerName: string }] {
  // tslint:disable-next-line:no-shadowed-variable
  const attrs = new NbiDimensions();
  const attributes: any = [];
  attributes.push(
    { field: attrs.CLIENT_GEN_ID, headerName: "Portfolio Client Id" },
    { field: attrs.CLIENT_GEN_NAME, headerName: "Portfolio Client Name" },

    { field: "fpv_beresctryname", headerName: "Booking Country" },
    { field: "fpv_beshortlabel", headerName: "Booking Entity" },
    { field: "agency_declongname", headerName: "Booking Place" },
    { field: "fpv_oeresctryname", headerName: "Originating Country" },
    { field: "fpv_oeresregcode", headerName: "Originating Region" },
    { field: "fpv_oeshortlabel", headerName: "Originating Entity" },
    { field: attrs.FPV_BL, headerName: "Business Line" },
    { field: attrs.FPV_SBL, headerName: "Sub Business Line" },
    { field: attrs.FPV_SSBL, headerName: "Sub Sub Business Line" },
    { field: attrs.CLIENT_CORIGRPCOMID, headerName: "GLBA client group ID" },
    { field: attrs.CLIENT_CORIGRPNAME, headerName: "GLBA client group name" },
    {
      field: attrs.CLIENT_GEN_COM_CTRY_LABEL,
      headerName: "Portfolio Client Country",
    },
    { field: attrs.CLIENT_GEN_REG_NAME, headerName: "Portfolio Client Region" },
    {
      field: attrs.CLIENT_GEN_SUB_REG_NAME,
      headerName: "Portfolio Client Sub Region",
    },
    { field: attrs.CLIENT_GEN_FUP_CLASS_LABEL, headerName: "Portfolio PCRU" },
    { field: attrs.CLIENT_GEN_SEGMENT, headerName: "Portfolio Client Segment" },
    { field: attrs.CLIENT_GEN_TYPL1, headerName: "Typology Level 1" },
    { field: attrs.CLIENT_GEN_TYPL2, headerName: "Typology Level 2" },
    { field: attrs.CLIENT_GEN_TYPL3, headerName: "Typology Level 3" },
    { field: attrs.SUB_GRP_ID, headerName: "Client Sub Group Id" },
    { field: attrs.SUB_GRP_FULL_NAME, headerName: "Client Sub Group" },
    { field: attrs.CLIENT_LEID, headerName: "Client Legal Entity Id" },
    { field: attrs.CLIENT_LENAME, headerName: "Client Legal Entity" },
    { field: attrs.CLIENT_GEN_LEVEL, headerName: "Portfolio Client Level" },
    { field: attrs.CLIENT_COUNTRY, headerName: "Commercial country of LE" },
    {
      field: attrs.CLIENT_GEN_CTRY_AXIS_LABEL,
      headerName: "Portfolio Client Steering Country",
    },
    {
      field: attrs.CLIENT_LEADCORIBANKER,
      headerName: "GLBA client lead banker",
    },
    { field: attrs.SALESBEN_SALES_LOCATION, headerName: "Sales Location" },
    {
      field: attrs.CLIENT_LE_RCT_CODE,
      headerName: "Client RCT for Legal Entity",
    },
    { field: attrs.CLIENT_GRPID, headerName: "Client Group Id" },
    { field: attrs.CLIENT_GRPID, headerName: "Client Group BDR CCIAL ID" },
    { field: attrs.CLIENT_CORIGRPSEGMENT, headerName: "GLBA client segment" },
    {
      field: attrs.CLIENT_CORI_CTRY_AXIS,
      headerName: "GLBA client steering country",
    },
    {
      field: attrs.GRP_FULL_NAME,
      headerName: "Client Group Name",
    },
    {
      field: attrs.CLIENT_GRP_COM_CONTINENT,
      headerName: "Client Group Continent Name",
    },
    {
      field: attrs.CLIENT_GRP_COUNTRY_AXIS,
      headerName: "Client Group Country Axis",
    },
    {
      field: attrs.CLIENT_GRP_COM_COUNTRY_GRP_NAME,
      headerName: "Client Group Country Grouping Name",
    },
    {
      field: attrs.GRP_COUNTRY,
      headerName: "Client Group Country Name",
    },
    { field: attrs.GRP_COMREGION, headerName: "Client Group Region Name" },
    {
      field: attrs.GRP_COMSUBREGION,
      headerName: "Client Group Sub Region Name",
    },
    {
      field: attrs.CLIENT_GRP_FUP_CLASS_LABEL,
      headerName: "Client Group PCRU",
    },
    { field: attrs.PRODUCT_LEVEL1, headerName: "Product Level1" },
    { field: attrs.PRODUCT_LEVEL2, headerName: "Product Level2" },
    { field: attrs.PRODUCT_LEVEL3, headerName: "Product Level3" },
    { field: attrs.GRP_TYPL1, headerName: "Client Group Typology Level 1" },
    { field: attrs.GRP_TYPL2, headerName: "Client Group Typology Level 2" },
    { field: attrs.GRP_TYPL3, headerName: "Client Group Typology Level 3" },
    { field: attrs.SUB_GRP_ID, headerName: "Client Sub Group BDR CCIAL ID" },
    { field: attrs.SUB_GRP_FULL_NAME, headerName: "Client Sub Group Name" },
    { field: attrs.CLIENT_LEID, headerName: "Client LE BDR CCIAL ID" },
    { field: attrs.CLIENT_LENAME, headerName: "Client LE Name" },
    { field: attrs.EC_ID, headerName: "Client EC BDR CCIAL ID" },
    { field: attrs.EC_FULL_NAME, headerName: "Client EC Name" },
    { field: attrs.BE_RES_CTRY_NAME, headerName: "Booking Entity Country" },
    { field: attrs.OE_RES_CTRY_NAME, headerName: "Originating Entity Country" },
    { field: attrs.OE_RES_REG, headerName: "Originating Entity Region" },
    { field: attrs.FPV_BE_RESG, headerName: "Booking Entity Region" },
    {
      field: attrs.NBI_GBIS_LEVEL_1_FUNCTIONAL_LABEL,
      headerName: "NBI breakdown level 1",
    },
    {
      field: attrs.NBI_GBIS_LEVEL_6_FUNCTIONAL_LABEL,
      headerName: "NBI breakdown level 6",
    },
    {
      field: attrs.NBI_GBIS_LEVEL_7_FUNCTIONAL_LABEL,
      headerName: "NBI breakdown level 7",
    },
    {
      field: attrs.CLIENT_GRP_SEGMENT,
      headerName: "Client Group Segment",
    },
    { field: attrs.PRODUCT_LABEL, headerName: "Product Label" },
    { field: attrs.PRODUCT_CODE, headerName: "Product Code" }
  );
  return attributes;
}

export function getDefaultAttributes(
  widgetName: string
): [{ field: string; headerName: string }] {
  const attributes: any = [];
  if (widgetName === widgetNames.CLIENTSNAPSHOT) {
    attributes.push(
      { field: attrs.FPV_BL, headerName: "Business Line" },
      { field: attrs.FPV_SBL, headerName: "Sub Business Line" }
    );
  } else if (widgetName === widgetNames.PORTFOLIO) {
    attributes.push({
      field: attrs.CLIENT_GEN_NAME,
      headerName: "Portfolio Client Name",
    });
  } else {
    attributes.push({
      field: attrs.GRP_FULL_NAME,
      headerName: "Client Group Name",
    });
  }

  return attributes;
}
